import UpdateTransferRequisition from "../../../../components/@documents/transfer_requisitions/UpdateTransferRequisition";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferRequisitionUpdatePage() {

    return (
        <UpdateTransferRequisition 
            routeType={routeTypes.retail}
        />
    )
}